// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-8ad","inner":"Footer_inner__1mtOu"};